import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const MLCourseDetails2 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>
            這堂課適合誰? <br />
            我可以在這堂課獲得什麼?
          </span>
        </h2>
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            熟悉資料科學與機器學習的核心理論，能獨立進行資料分析、視覺化與模型建構。
          </li>
          <li>
            深度認識主流監督式與無監督學習演算法（如線性迴歸、決策樹、KMeans、PCA等），並理解其數學原理與應用場景。
          </li>
          <li>
            使用 Python
            及主流套件（NumPy、Pandas、Matplotlib等）處理資料、訓練模型與評估效能。
          </li>
          <li>
            完成 7 個真實資料集
            Lab，從資料清理、特徵工程到模型訓練與優化，提升資料思維與實戰能力。
          </li>
          <li>
            掌握正則化、交叉驗證、特徵工程、模型評估等機器學習實用技巧，能解決常見問題。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對資料科學、機器學習、人工智慧有興趣的學習者</li>
          <li>希望用 Python 做資料分析與機器學習的工程師或學生</li>
          <li>剛入門 AI 領域，想建立完整基礎的初學者</li>
          <li>想強化資料處理與模型應用能力的進階學習者</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default MLCourseDetails2;
